export default {
  data () {
    return {
      screenWidth: process.client && window ? window.innerWidth : 0
    }
  },

  computed: {

  },

  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onScreenResize);
    })
  },

  methods: {
    onScreenResize () {
      this.screenWidth = process.client && window ? window.innerWidth : 0
    }
  }
}
